/**
 * Default fixture for appointment_categories.
 * Single source of truth for Figma-matching defaults.
 *
 * Used by:
 * - Server seed during org provisioning
 * - Client-side "Reset to Default" action
 */

export interface AppointmentCategoryDefault {
  name: string;
  description: string;
  color_hex: string;
  typical_duration_mins: number | null;
  sort_order: number;
}

export const DEFAULT_APPOINTMENT_CATEGORIES: AppointmentCategoryDefault[] = [
  {
    name: 'Consultation',
    description: 'General consultation appointments',
    color_hex: '#3b82f6',
    typical_duration_mins: 30,
    sort_order: 10,
  },
  {
    name: 'Follow-up',
    description: 'Follow-up visits',
    color_hex: '#22c55e',
    typical_duration_mins: 15,
    sort_order: 20,
  },
  {
    name: 'Procedure',
    description: 'Medical procedures',
    color_hex: '#ef4444',
    typical_duration_mins: 60,
    sort_order: 30,
  },
  {
    name: 'Lab Work',
    description: 'Laboratory tests',
    color_hex: '#f59e0b',
    typical_duration_mins: 30,
    sort_order: 40,
  },
];
